import { PROJECT_REVIEW_SECTION_LABELS } from '../constants';
import {
  ProjectReviewEntity,
  ProjectReviewSection,
  ProjectReviewSectionType,
  ProjectReviewViolation,
  SummaryReviewItem,
} from '../types';

const toEntity = (item: SummaryReviewItem, ordinal: number): ProjectReviewEntity => ({
  ordinal,
  entityId: item.entityId,
  name: item.entityName,
  code: item.entityCode,
  changes: item.changes.map(change => ({
    changeType: change.changeType,
    property: change.property,
    oldValue: change.oldValue,
    newValue: change.newValue,
    occurredAt: change.occurredAt,
    author: change.changedBy,
    commitId: change.commitId,
  })),
  violations: item.violations.map(violation => ({
    code: violation.code,
    entityType: item.entityType,
    entityId: item.entityId,
    message: violation.message,
  })),
  comment: item.comment,
});

export const getStaleSummaryReviewViolations = (items: SummaryReviewItem[]): ProjectReviewViolation[] => {
  const sectionOrder = Object.keys(PROJECT_REVIEW_SECTION_LABELS) as ProjectReviewSectionType[];

  return items
    .filter(item => !sectionOrder.includes(item.section as ProjectReviewSectionType))
    .flatMap(item =>
      item.violations.map(violation => ({
        code: violation.code,
        entityType: item.entityType,
        entityId: item.entityId,
        message: violation.message,
      })),
    );
};

const groupSummaryReviewItems = (items: SummaryReviewItem[]): ProjectReviewSection[] => {
  const sectionOrder = Object.keys(PROJECT_REVIEW_SECTION_LABELS) as ProjectReviewSectionType[];

  return sectionOrder.reduce<ProjectReviewSection[]>((sections, section) => {
    const sectionItems = items.filter(item => item.section === section);
    if (!sectionItems.length) return sections;

    const entityTypes = Array.from(new Set(sectionItems.map(item => item.entityType)));

    sections.push({
      section,
      groups: entityTypes.map(entityType => ({
        entityType,
        entities: sectionItems.filter(item => item.entityType === entityType).map(toEntity),
      })),
    });

    return sections;
  }, []);
};

export default groupSummaryReviewItems;
